import script from "./WReportsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./WReportsTable.vue?vue&type=script&setup=true&lang=ts"

import "./WReportsTable.vue?vue&type=style&index=0&id=292eacf7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-292eacf7"]])

export default __exports__